import { useDispatch } from "react-redux";

import { CommentsSolidV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";
import Thumbnail from "./shared/Thumbnail";

const LeadEngagedWithChatbotActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={CommentsSolidV6}>
            Engaged with Website Chat
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={STYLES.contentContainer2}>
        <div className={`${STYLES.contentContainer} tw-text-14d`}>
          {activity.data?.subjectPhoneNumber && (
            <DataField label="Phone" data={activity.data?.subjectPhoneNumber} />
          )}
          {activity.data?.subjectEmail && <DataField label="Email" data={activity.data?.subjectEmail} />}
          {activity?.content && <DataField label="Message" data={activity?.content} />}
          <ActivityBtns
            callHandlr={() => {
              if (activity.data?.personUuid) {
                dispatch(
                  setCallParams({
                    leadUuids: [activity.data?.personUuid],
                    callSource: "Favorite Property Activity",
                  }),
                );
              }
            }}
            containerClassName="!tw-mt-8px"
          />
        </div>
        {activity.imageUrl && <Thumbnail src={activity.imageUrl} />}
      </div>
    </ActivityContainer>
  );
};

export default LeadEngagedWithChatbotActivity;

LeadEngagedWithChatbotActivity.propTypes = {
  ...activityCommonPropTypes,
};

LeadEngagedWithChatbotActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
